import React, { useEffect, useRef } from "react";
import Head from "next/head";
import { isMobileOrTablet } from "./Views/MobileClassRenderer";
import prefixCSS from "../util/prefixCSS"
// import { parse, stringify } from "css"

const PageHead = React.forwardRef(
  (
    {
      eventTitle,
      pageTitle,
      hasPrefix = true,
      prefix = "vVenues | ",
      suffix,
      hasUnreadMessages,
      pageCustomCss = null,
    },
    ref
  ) => {

    function getPageCustomCSS() {
      return pageCustomCss && prefixCSS(pageCustomCss, "#page#page")
    }
    return (
      <Head>
        <title ref={ref}>
          {hasPrefix && prefix}
          {pageTitle && eventTitle ? `${eventTitle} - ` : ""}
          {pageTitle ? pageTitle : eventTitle}
          {suffix && ` - ${suffix}`}
        </title>
        <link
          rel="icon"
          href={
            hasUnreadMessages ? "/favicon-notification.png" : "/faviconnew.png"
          }
        />
        {isMobileOrTablet() && (
          <>
            {/* <meta
              name="viewport"
              content="width=device-width, initial-scale=1, maximum-scale=1"
            /> */}
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="viewport" content="viewport-fit=cover, width=device-width, initial-scale=1, maximum-scale=1" />
          </>
        )}
        <style>{getPageCustomCSS()}</style>
      </Head>
    );
  }
);

export default PageHead;
